<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-if="form.value.length > 0">
                            <span v-for="(form1, i) in form.value" v-if="form1.codeCode == receptionData[form.id]">{{form1.codeName}}</span>
                        </p>
						<p class="mg-b-0 text-left" v-else-if="form.name == 'Reception No'">
                            <a href='#modal5' @click='sendId(properties.uid)' data-toggle="modal" data-animation="effect-flip-horizontal">{{receptionData[form.id]}}</a>
                        </p>
						<p class="mg-b-0 text-left" v-else>
                            {{receptionData[form.id]}}
                        </p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
						<p class="mg-b-0 text-left" v-for="(form1, j) in form.value" v-if="receptionData[form.id] == form1.codeCode">{{form1.codeName}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{receptionData[form.id]}}</p>
					</div>
				</ul>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components overflow-hidden">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">View</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} View</h4>
						</nav>

					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name.replace('_completion',''), params:{mid:this.properties.mid, type:'list'}}"><i data-feather="file" class="wd-10 mg-r-5"></i>list</router-link>
					</div>
				</div>
				<div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
					<div class="d-none d-md-block tx-right-f">
						<a href="" @click="excelExport()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Excel</a>
                        <a href="" v-if="imgData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="imgDialogHandler('img')" ><feather type="image" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLE BOX</a>
                        <button v-if="this.downloadList.Excel.length > 0" @click="excelDialogHandler()" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Sample_List</button>
                        <a href="" v-if="buttonFlag" @click="ToMediageSendDataApi()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal" ><feather type="clipboard" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Result Report</a>
                        <a href="" v-if="buttonFlag" @click="cancellationMediage()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal" ><feather type="x-circle" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Cancel</a>
					</div>
					<section>
						<b-table
							id="btable"
							class="overflow-x-hidden b-table-fix-header" 
							:data="isEmpty ? [] : sampleData"
							:checked-rows.sync="checkedRows"
							checkable
							hoverable
							striped
						>
							<template slot-scope="props">
								<b-table-column v-for="(form, i) in sampleHeader"
									v-if="i == 0"
									:key="i"
									field="no"
									label="No">
									{{ props.row.no }}
								</b-table-column>
                                <!-- <b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
                                    <a href='#modal5' @click='sendId(properties.uid)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"> {{ props.row[form.columnCode] }} </a>
                                </b-table-column> -->
								<b-table-column v-for="(form, i) in sampleHeader"
									v-if="i > 0"
									:key="i"
									:field="form.columnCode"
									:label="form.columnName"
									centered >
									{{ props.row[form.columnCode] }}
								</b-table-column>
							</template>
							<template slot="empty">
								<section class="section">
									<div class="content has-text-grey has-text-centered">
										<p>Nothing here.</p>
									</div>
								</section>
							</template>
						</b-table>
					</section>
				</div><!-- card -->
                <v-app>
                    <v-row justify="space-around">
                        <v-col cols="auto">
                        <v-dialog v-model="imgDialog" transition="dialog-bottom-transition" max-width="600" style='z-index:20001;'>
                            <!-- <v-system-bar lights-out></v-system-bar> -->
                                <v-carousel>
                                <v-carousel-item
                                v-for="(item,i) in imgData"
                                :key="item.id"
                                :src="'data:'+item.type.trim()+';base64,'+ item.img"
                                reverse-transition="fade-transition"
                                transition="fade-transition">
                                <v-btn depressed color="primary" block @click="imgDialogHandler('delete')">
                                    Delete Image
                                </v-btn>
                                <v-dialog v-model="deleteDialog" transition="dialog-bottom-transition" max-width="300" style='z-index:20001;'>
                                    <div class="text-center">
                                        <v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block" >
                                            <div class="text-body-2 mb-4"> Are you sure you want to delete this image? </div>
                                            <v-btn class="ma-1" color="grey" plain @click="deleteDialog = false">Cancel</v-btn>
                                            <v-btn :loading="deleteLoading" class="ma-1" color="error" plain @click="deleteImgFile(item)"> Delete </v-btn>
                                        </v-sheet>
                                    </div>
                                </v-dialog>
                                </v-carousel-item>
                            </v-carousel>
                        </v-dialog>
                        </v-col>
                    </v-row>
                </v-app>
			</div>
		</div>
        	<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered chat-width" role="document">
                    <div class="modal-content tx-14 chat-height">
                        <div class="modal-header">
                        <h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div class="modal-body">
                            <Chat></Chat>
                        </div>
                    </div>
                </div>
            </div><!-- chat modal -->
            <v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="excelDialog"
                    max-width="500px"
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-card-title>
                            Download Report
                            </v-card-title>
                            <v-card-text>
                            <v-select
                                v-model="selectExcel"
                                :items="downloadList['Excel']"
                                label="Select a Excel"
                                item-value="text"
                            ></v-select>
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="secondary"
                                text
                                @click="excelDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="loadExcel()"
                            >
                                Load
                            </v-btn>
                            <v-btn
                                color="accent"
                                text
                                @click="deleteExcel_DialogHandler()"
                            >
                                Delete
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div> 	
        </v-app>
		 <v-app id="inspire">
			<v-row justify="center">
				<v-dialog
					v-model="deleteExcelDialog"
					persistent
					max-width="290"
				>
					<v-card>
					<v-card-title class="text-h6">
						Are you sure you want to delete?
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
						color="secondary"
						text
						@click="deleteExcelDialog = false"
						>
						Cancel
						</v-btn>
						<v-btn
						color="primary"
						text
						@click="deleteExcel()"
						>
						OK
						</v-btn>
					</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
		</v-app>
        </div>
</template>
<script>
	import common from '@/views/Common/common.js'

	// Header의 메뉴 정보 호출을 위한 bus event
	import {bus} from '../../main';
	import Chat from "@/views/Common/Chat";
	import excel from '@/views/Common/excel.js';

	export default {
		name: 'Completion',
		props: ['properties'],
		data(){
			return{
				mainName:'',
				subName:'',

				mid:'',
				sid:'', // sample list id

				/* Reception input Form */
				receptionHeader:[], // 입력 값 header column
				inputSearchForms:[], // 입력 input form
				dateSearchForms:[], // 입력 date form
				checkboxSearchForms:[], // 입력 radio form

				/* Reception input Form Value */
				receptionData: [],

				/* Sample list Form */
				sampleData: [],
				sampleHeader: [],
				isEmpty: false,
				isPaginated: true,
				total: 0,
				page: 1,
				perPage: 1000,

				/* Loading */
				isLoading: false,
				isFullPage: true,

                /* Mediage button flag*/ 
                buttonFlag : false,
				width: 0,
				height: 0,

				checkedRows: [],

                // image upload
				imgFileFormData: new FormData,
				imgFileHandleFlag: false,
				pasteForm: new FormData,
				pasteFlag: false,
				pasteCount:0,
				imgId: [],
				imgData: [],
                imgDialog : false,
                deleteDialog : false,
                deleteLoading : false,
                selectImg : {},

				// excel upload
				excelFileFormData: new FormData,
				excelFileHandleFlag: false, 
				excelId: [],
				excelDialog: false,
				deleteExcelDialog: false,
				selectExcel: '',
				downloadList: {
					"Excel": [],
				},
			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyHeader();
                this.getImgFile();
                this.getExcel();
			});
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
            
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
		},
		methods: {
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader(){
				this.openLoading();
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.msid = data[2];
				this.receptionHeader = data[3];
				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];
				for(let i in this.receptionHeader){
					if(this.receptionHeader[i].columnType == "LIST"){
						if(this.receptionHeader[i].columnAttr =='statecode'){
							this.inputSearchForms.push({'name':this.receptionHeader[i].columnName, 'value':this.receptionHeader[i].code, 'id':this.receptionHeader[i].columnCode ,'division':'O'});
						}else{
							this.checkboxSearchForms.push({'name':this.receptionHeader[i].columnName, 'id':this.receptionHeader[i].columnCode, 'value':this.receptionHeader[i].code, 'division':this.receptionHeader[i].columnDivision});
						}
					}else if(this.receptionHeader[i].columnType == "DATE"){
						this.dateSearchForms.push({'name':this.receptionHeader[i].columnName, 'value':'', 'id':this.receptionHeader[i].columnCode, 'division':this.receptionHeader[i].columnDivision});
					}else if(this.receptionHeader[i].columnType == "COUNT"){
					}else{
						if(this.receptionHeader[i].columnName == 'No'){
						}else{
							this.inputSearchForms.push({'name':this.receptionHeader[i].columnName, 'value':'', 'id':this.receptionHeader[i].columnCode, 'division':this.receptionHeader[i].columnDivision});
						}
					}
				}
				this.classifySampleHeader();
			},
			/*
			* Load Data Sample Headers
			*/
			async classifySampleHeader(){
				let data = common.detailSamples(this.menuData);
				this.ssid = data[0];
				this.sampleHeader = data[1];
				this.classifyData();
            },
            async getImgFile() {
			//img 가져오기
                if(!common.isNull(this.properties.uid)){
                    var params = []; 
                    params = {'uid' : this.properties.uid};
                    var request = {params : params}
                    await this.$axios.get(`${this.$apiHost}/${this.$route.name.replace("_completion", "")}/image`, request)
                    .then(res=>{
                        for (let i in res.data) {
                            this.imgData.push(res.data[i]);
                        }
                        if (!common.isNull(this.imgData)) {
                            for (let i in this.imgData) {
                                this.imgId.push(this.imgData[i].id);
                                let image = this.imgData[i].img;
                            }
                        }
                    }).catch(err=>{console.log(err)});
                } 
		    },
            async deleteImgFile(param) {
                try {
                    var params = []; 
                    params = {'id' : param.id};
                    var request = {params : params}
                    this.imgId.splice(this.imgId.indexOf(param.id),1);
                
                    if (!common.isNull(param.id)) {
                        await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_completion','') + '/delimage', request)
                        .then(res => {
                            if (res.data) {
                                this.$router.go({name:this.$route.name});
                                // this.$buefy.dialog.alert({
                                // 	message: 'Complete!',
                                // 	size: 'is-medium',
                                // 	type: 'is-danger'
                                // })
                            return false;
                            }
                        });
                    }
                } catch (error) {
                    console.log(error)
                }
		    },
            /*
			* Send Data to MEDIAGE
			*/
			async ToMediageSendDataApi(){
				console.log(this.checkedRows)
				if (this.checkedRows.length) {
					for (let i in this.checkedRows) {
						if (this.checkedRows[i].mediage == "결과통보") {
								this.$buefy.dialog.alert({
								message: `No.${this.checkedRows[i].no} sample has already been reported.`,
								size: 'is-medium',
								type: 'is-danger'
							})
							return false;
						}
					}
					this.$buefy.dialog.confirm({
						message: 'Are you sure you want to reported?',
						size: 'is-medium',
						onConfirm: async () => {
							var params = {};
							params['samples'] = this.checkedRows;
							await this.$axios.post(this.$apiHost + '/exapi/report', params).then(res => {
								if (res.data.flag) {
									this.$buefy.notification.open({
										duration: 2000,
										message: res.data.message,
										position: 'is-bottom-right',
										type: 'is-success',
										hasIcon: true
									})
								} else {
									this.$buefy.notification.open({
										duration: 2000,
										message: res.data.message,
										position: 'is-bottom-right',
										type: 'is-danger',
										hasIcon: true
									})
								}
								// this.$router.push({
								//     name: "receptions_completion",
								//     params: { mid: this.properties.mid, uid: uid, type: "detail" }
								// });
							});
						},
						onCancel: () => {
							this.isLoading = false;
							return false;
						}
					});

				} else {
					this.$buefy.dialog.alert({
						message: 'Please check row',
						size: 'is-medium',
						type: 'is-danger'
					})
				}
            },
            /*
			* Send Cancellation to MEDIAGE 
			*/
			async cancellationMediage(){
				if (this.checkedRows.length) {
					for (let i in this.checkedRows) {
						if (this.checkedRows[i].mediage == "결과취소") {
								this.$buefy.dialog.alert({
								message: `No.${this.checkedRows[i].no} sample has already been cancellation.`,
								size: 'is-medium',
								type: 'is-danger'
							})
							return false;
						}
					}
					this.$buefy.dialog.confirm({
						message: 'Are you sure you want to cancel?',
						size: 'is-medium',
						onConfirm: async () => {
							this.openLoading();
							var params = {};
							params['samples'] = this.checkedRows;
							await this.$axios.post(this.$apiHost + '/exapi/cancel', params).then(res => {
								if (res.data.flag) {
									this.$buefy.notification.open({
										duration: 2000,
										message: res.data.message,
										position: 'is-bottom-right',
										type: 'is-success',
										hasIcon: true
									})
								} else {
									this.$buefy.notification.open({
										duration: 2000,
										message: res.data.message,
										position: 'is-bottom-right',
										type: 'is-danger',
										hasIcon: true
									})
								}
								this.isLoading = false;
								// this.$router.push({
								//     name: "receptions_completion",
								//     params: { mid: this.properties.mid, uid: uid, type: "detail" }
								// });
							});
						},
						onCancel: () => {
							this.isLoading = false;
							return false;
						}
					});

				} else {
					this.$buefy.dialog.alert({
						message: 'Please check row',
						size: 'is-medium',
						type: 'is-danger'
					})
				}
            },
            
			/*
			* Load Data Headers & Samples Data
			*/
			async classifyData(){
				if(!common.isNull(this.properties.uid)){
					var params = [];
					params = {'ssid' : this.ssid};
					params['uid'] = this.properties.uid;
					var request = {params : params}
					await this.$axios.get(this.$apiHost + '/receptions/detail', request)
					.then(res=>{
						this.receptionData = res.data;
						this.buttonFlag = res.data.mediFlag;
					}).catch(err=>{console.log(err)});
                    this.sampleData = [];
                
					for(let i in this.receptionData.samples){
						this.receptionData.samples[i].no = Number(i) + 1;
						for(let j in this.sampleHeader){
							if(this.sampleHeader[j].columnType === 'LIST'){
								for(let k in this.sampleHeader[j].code){
									if(this.sampleHeader[j].code[k].codeCode == this.receptionData.samples[i][this.sampleHeader[j].columnCode]){
										this.receptionData.samples[i][this.sampleHeader[j].columnCode] = this.sampleHeader[j].code[k].codeName;
									}
								}
							}
						}
						this.sampleData.push(this.receptionData.samples[i]);
					}
					if (this.buttonFlag) {
						this.sampleHeader.push({columnCode:'mediage', columnName:'Mediage 전송상태'})
					}
					let height = (Number(this.height) - (Number(this.height)/3))+'px';
					document.getElementById('btable').style.height = height;
					this.isLoading = false;
				}
			},
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
            imgDialogHandler(input) {
                if(input == 'img'){
                    this.imgDialog = true;
                }else if(input == 'delete'){
                    this.deleteDialog = true;
                }
            },
            async excelDialogHandler(){
                this.excelDialog = true;
                return false;
		    },
            async getExcel(){
                try {
                    if(!common.isNull(this.properties.uid)){
                        let params = [];
                        params = {
                            'id' : this.properties.uid
                        };
                        let request = {params : params};
                        const result = await this.$axios.get(`${this.$apiHost}/files/excel`, request);
                        if (result.data.length > 0) {
                            let path = [];
                            for (let i of result.data) {
                                path.push(i.fileName)
                                this.excelId.push(i.id)
                            }
                            this.downloadList.Excel = path;
                            this.downloadList.Excel_info = result.data;
                        }
                        return false;
                    } else {
                        return false;
                    }

                } catch (error) {
                    console.log(error);
                }
		    },
            async loadExcel(){
                try {
                    if (this.selectExcel) {
                        let path = `https://lims.accugenelab.com/excel/samplelist/${this.selectExcel}`;
                        window.open(path);

                        this.selectExcel = '';
                        this.excelDialog = false;

                        return false;
                    } else {
                        this.$buefy.dialog.alert({
                            message: 'Please select a report',
                            size: 'is-medium',
                            type: 'is-danger'
                        })
                        return false;
                    }

                } catch (error) {
                    console.log(error);
                }
		    },
            async deleteExcel_DialogHandler(){
                this.deleteExcelDialog = true;
                return false;
            },
            /*
            * QC Report 
            */
            async deleteExcel(){
                try {
                    if (this.selectExcel) {
                        let params = []; 
                        let deleteReport = this.downloadList.Excel_info.find(item => item.fileName === this.selectExcel);
                        let { id, fileName } = deleteReport;
                        params = {
                            id, 
                            fileName,
                        };
                        let request = {params : params}
                        const deleteData = await this.$axios.delete(`${this.$apiHost}/files/excel`, request);
                        // list
                        this.downloadList.Excel = this.downloadList.Excel.filter(item => item !== this.selectExcel);
                        // copy id 
                        this.excelId = this.excelId.filter(item => item !== id);
                        this.selectExcel = '';
                        this.deleteExcelDialog = false;
                        return false;
                    } else {
                        this.$buefy.dialog.alert({
                            message: 'Please select a report',
                            size: 'is-medium',
                            type: 'is-danger'
                        })
                        deleteExcelDialog = false;
                        return false;
                    }

                } catch (error) {
                    console.log(error);
                }
            },  
			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true
				setTimeout(() => {
					this.isLoading = false
				}, 10 * 1000)
            },
            	/*
			* Handsontable Reception no click is chat.vue send uuid
			*/
			sendId(id){
				bus.$emit("receptid", id);
			},
			excelExport(){ 
				excel.excelExportDataParser(this.sampleData, this.sampleHeader);
			},
		},
		components: {
            Chat
		},
		computed: {
		},
		watch: {
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/Reception/CompletionForm.vue